// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__17TwD","content":"LoadingAlert_content__2yAqS"};